<ion-item *ngIf="type === 'item'" button (click)="updateMedia()">
    <ion-label>{{ 'Youtube link' | translate }}</ion-label>
    <ion-icon color="secondary" slot="start" name="logo-youtube"></ion-icon>
    <ion-icon *ngIf="match.dist.media?.length" color="danger" slot="end" name="trash"></ion-icon>
</ion-item>

<div *ngIf="type === 'button'" class="ion-text-center">
    <ion-button (click)="updateMedia()" expand="block" fill="clear">
        Add YouTube link
    </ion-button>
</div>